import { DataSource } from '@angular/cdk/collections';
import { GetCustomer } from '../generated-client/generated-client';
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { PaginationBaseService } from 'ng-lightquery';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CustomersService extends PaginationBaseService<GetCustomer> implements DataSource<GetCustomer> {
  protected http: HttpClient;

  constructor() {
    const http = inject(HttpClient);

    super(http);
    this.http = http;

    this.baseUrl = '/api/customers';
    this.sort = { propertyName: 'name', isDescending: true };
  }

  connect(): Observable<GetCustomer[]> {
    return this.paginationResult.pipe(map(r => r.data));
  }

  disconnect() {}
}
